import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { deleteRuta } from "../functions";
const RutaDelete = ({openDelete,setOpenDelete}) => {
    const dispatch = useDispatch();
    const { rutaIdSelected } = useSelector(({ ruta }) => ruta);
    const deleteFnc = async () =>{
    await deleteRuta(rutaIdSelected)(dispatch);
    setOpenDelete(false);
}
    return (
        <>
            <Dialog
            open={openDelete}
            onClose={()=>setOpenDelete(false)}
            >
                <DialogTitle>
                    <Typography variant="title">{"Eliminar"}</Typography>
                </DialogTitle>
                <DialogContent>
                    <Typography variant="subtitle">
                        {"Continuar con la Eliminación del Ruta"}
                    </Typography>

                </DialogContent>
                <DialogActions>
                    <Button
                    onClick={()=>setOpenDelete(false)} color="primary"
                    >
                        Cancelar
                    </Button>
                    <Button onClick={deleteFnc} color="primary"
                    >
                        Eliminar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}
export default RutaDelete;